import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { CustomerFacade } from '../../+store/customer/customer.facade';
import {
  Gender,
  ILead,
  NewCustomerDTO
} from '@appgen-health-crm/api-interfaces';

@Component({
  selector: 'portals-emr-customer-create',
  templateUrl: './customer-create.component.html',
  styleUrls: ['./customer-create.component.less']
})
export class CustomerCreateComponent implements OnInit, OnDestroy {
  constructor(
    private fb: FormBuilder,
    private customerFacade: CustomerFacade
  ) {}
  @Input() lead: ILead;
  @Input() goToCustomer: boolean;
  
  active = true;
  loading$ = this.customerFacade.loading$;

  FG = this.fb.group({
    firstName: ['', [Validators.required]],
    lastName: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    phone: ['', []],
    dob: [null, []],
    gender: ['', []]
  });

  ngOnInit() {
    if (this.lead) {
      this.FG.patchValue({
        ...this.lead
      } as any);
    }
  }

  ngOnDestroy() {
    this.active = false;
  }

  submit() {
    for (const i in this.FG.controls) {
      this.FG.controls[i].markAsDirty();
      this.FG.controls[i].updateValueAndValidity();
    }

    if (this.FG.invalid) {
      return;
    }

    const { firstName, lastName, email, phone, gender } = this.FG.value;
    let formattedDob;
    if (this.FG.value.dob) {
      formattedDob = new Date(this.FG.value.dob);
      formattedDob.setHours(12);
      formattedDob = formattedDob.toISOString().substring(0, 10);
    }
    const request: NewCustomerDTO = {
      email,
      firstName,
      lastName,
      phone,
      dob: formattedDob,
      gender: gender as Gender
    };

    this.customerFacade.createCustomer(request, this.lead, this.goToCustomer);
  }
}
